
import { CheckCircle, Search, Calendar, MessageSquare } from "lucide-react";

const steps = [
  {
    icon: <Search className="h-10 w-10 text-crimson" />,
    title: "Search Alumni",
    description: "Browse profiles of alumni from top institutions based on expertise, school, or major."
  },
  {
    icon: <Calendar className="h-10 w-10 text-crimson" />,
    title: "Book a Session",
    description: "Select a time slot that works for you and specify what you need help with."
  },
  {
    icon: <MessageSquare className="h-10 w-10 text-crimson" />,
    title: "Connect & Learn",
    description: "Meet virtually with your alumni mentor and get personalized guidance."
  },
  {
    icon: <CheckCircle className="h-10 w-10 text-crimson" />,
    title: "Achieve Results",
    description: "Apply the feedback and insights to improve your applications, essays, or interview skills."
  }
];

const HowItWorks = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">How It Works</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            A simple process to connect with alumni and get the guidance you need
          </p>
        </div>
        
        <div className="relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-silver/30 z-0"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="bg-white p-6 rounded-lg shadow-md relative z-10 animate-fade-in"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="flex justify-center mb-6">
                  <div className="p-3 bg-crimson/10 rounded-full">
                    {step.icon}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-center mb-3">{step.title}</h3>
                <p className="text-gray-600 text-center">{step.description}</p>
                
                <div className="hidden md:flex absolute top-6 left-1/2 -translate-x-1/2 -mt-3 bg-white rounded-full border-4 border-white">
                  <div className="bg-crimson text-white w-8 h-8 rounded-full flex items-center justify-center font-bold">
                    {index + 1}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
